/** @internal */
// @ts-ignore
export const GeographyIdType = {
    SubmarketId: 0,
    ClusterId: 1,
    CoreBasedStatisticalAreaId: 2,
    ResearchMarketId: 3,
    NationalId: 4,
    CountyId: 5,
    CityId: 6,
    NationalMajorId: 7,
    CollegeId: 20,
    CollegeNationalId: 27,
    CoStarProductMarketId: 31,
    CoStarProductCountryMajorMarketsId: 37,
    CoStarProductCountryId: 44,
    CoStarCollegeCountryId: 47
};
